/** Lookup.ParticipantRoles ids of the three decision signers. */
export enum DecisionSignerRole {
	CommitteeChairman = 4,
	FirstMember = 5,
	SecondMember = 6,
}
